import { render, staticRenderFns } from "./r-card-page.vue?vue&type=template&id=d4620ca6"
import script from "./r-card-page.vue?vue&type=script&lang=js"
export * from "./r-card-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4620ca6')) {
      api.createRecord('d4620ca6', component.options)
    } else {
      api.reload('d4620ca6', component.options)
    }
    module.hot.accept("./r-card-page.vue?vue&type=template&id=d4620ca6", function () {
      api.rerender('d4620ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card/r-card-page.vue"
export default component.exports